import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useStartAPetitionPageState } from '#src/app/pages/startAPetitionV2/pageContext';
import { useImageJob } from '#src/app/pages/startAPetitionV2/shared/hooks';

type UseOptionalPreviewReturn = ModelHookResult<
	{
		ask: string;
		description: string;
		jobStatus: 'idle' | 'pending' | 'success' | 'error';
		imageSrc: string | undefined;
	},
	{ back: () => void; submit: () => void }
>;
export function useOptionalPreview(): UseOptionalPreviewReturn {
	const { data, actions } = useStartAPetitionPageState();
	const track = useTracking();

	const { status } = useImageJob({ enabled: true });

	const back = useCallback(() => {
		void track('sap_step_back', { step: 'optional_preview' });

		actions.send({ type: 'back' });
	}, [actions, track]);

	const submit = useCallback(() => {
		void track('sap_step_submit', { step: data.normalizedStep, step_data: {}, step_data_raw: '{}' });

		actions.send({ type: 'submit' });
	}, [actions, data.normalizedStep, track]);

	return {
		data: {
			ask: data.draft?.petitionDraft?.ask ?? '',
			description: data.draft?.petitionDraft?.description ?? '',
			jobStatus: status,
			imageSrc: data.draft?.petitionDraft?.image?.url,
		},
		actions: { back, submit },
	};
}
